import { graphql, useStaticQuery } from "gatsby"

export default function useSectionData() {
  const data = useStaticQuery(graphql`
    query getSectionData {
      file(sourceInstanceName: {eq: "settings"}, name: {eq: "section-order"}) {
        id
        name
        childMarkdownRemark {
          html
          frontmatter {
            sections
          }
        }
      }
      allFile(filter: {sourceInstanceName: {eq: "sections"}}) {
        edges {
          node {
            id
            name
            relativePath
            childMarkdownRemark {
              id
              frontmatter {
                subtitle
                survey_results
                title
                show_title_in_content
              }
              html
            }
          }
        }
      }
    }
  `)
  return data
}
